import { render, staticRenderFns } from "./ProductCharts.vue?vue&type=template&id=07393925&"
import script from "./ProductCharts.vue?vue&type=script&lang=js&"
export * from "./ProductCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports